import React from "react";
import { motion } from "framer-motion";
import Button, { ButtonType } from "../Assets/Button";

interface ErrorModalProps {
  message: string;
  onClose: () => void;
  onCancel?: () => void;
  showCancel?: boolean;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  message,
  onClose,
  onCancel,
  showCancel = true,
}) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        className="bg-gradient-to-br from-red-100 to-white rounded-lg p-6 max-w-md w-full shadow-xl border border-red-300"
      >
        <div className="mb-4">
          <div className="flex items-center gap-2 bg-red-100 text-red-600 rounded-full px-4 py-2 shadow-md mb-4 w-fit">
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 9v2m0 4h.01M12 2a10 10 0 1010 10A10 10 0 0012 2z"
              />
            </svg>
            <div>
              <h3 className="text-lg font-medium text-red-primary">Error</h3>
            </div>
          </div>
          <p className="mt-2 text-sm text-red-secondary">{message}</p>
        </div>
        <div className="flex justify-end space-x-3">
          {showCancel && (
            <Button
              type={ButtonType.Cancel}
              onClick={() => {
                onCancel?.();
                onClose();
              }}
              className="text-sm"
            >
              Cancel
            </Button>
          )}
          <Button type={ButtonType.Error} onClick={onClose} className="text-sm">
            OK
          </Button>
        </div>
      </motion.div>
    </div>
  );
};

export default ErrorModal;
